



































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Arrows extends Vue {

  beginning = true

  @Prop({ default: 'smallGroup' }) readonly type!:
    | 'largeGroup'
    | 'smallGroup'
    | 'background'

  types: any = {
    largeGroup: {
      size: {
        x: 630,
        y: 650,
      },
      arrows: [
        {
          color: 'blue',
          offset: {
            y: -200,
            x: -190,
          },
          scale: 1,
          animationDuration: 10,
          opacity: 1,
        },
        {
          color: 'blue-reverse',
          offset: {
            y: 100,
            x: 150,
          },
          scale: 0.7,
          animationDuration: 8,
          opacity: 1,
        },
        {
          color: 'light-blue',
          offset: {
            y: -10,
            x: -390,
          },
          scale: 0.85,
          animationDuration: 6,
          opacity: 1,
        },
        {
          color: 'purple',
          offset: {
            y: 350,
            x: -100,
          },
          scale: 0.7,
          animationDuration: 7,
          opacity: 1,
        },
        {
          color: 'light-blue-reverse',
          offset: {
            y: 1000,
            x: 600,
          },
          scale: 0.4,
          animationDuration: 3,
          opacity: 1,
        },
      ],
    },
    smallGroup: {
      size: {
        x: 630,
        y: 650,
      },
      arrows: [
        {
          color: 'blue-reverse',
          offset: {
            y: -150,
            x: -150,
          },
          scale: 1,
          animationDuration: 20,
          opacity: .1,
        },
        {
          color: 'light-blue-reverse',
          offset: {
            y: 100,
            x: -350,
          },
          scale: .8,
          animationDuration: 20,
          opacity: .1,
        },
        {
          color: 'purple',
          offset: {
            y: 150,
            x: 150,
          },
          scale: 0.7,
          animationDuration: 7,
          opacity: 1,
        },
        {
          color: 'blue-reverse',
          offset: {
            y: 350,
            x: 150,
          },
          scale: 0.7,
          animationDuration: 8,
          opacity: 1,
        },
        {
          color: 'light-blue-reverse',
          offset: {
            y: 1000,
            x: 300,
          },
          scale: 0.4,
          animationDuration: 3,
          opacity: 1,
        },
      ],
    },
    background: {
      size: {
        x: 1630,
        y: 2050,
      },
      arrows: [
        {
          color: 'blue-reverse',
          offset: {
            y: -300,
            x: -500,
          },
          scale: 3.2,
          animationDuration: 25,
          opacity: .1,
        },
        {
          color: 'blue-reverse',
          offset: {
            y: -50,
            x: -250,
          },
          scale: 1.5,
          animationDuration: 20,
          opacity: .1,
        },
      ],
    },
    'background-accent': {
      size: {
        x: 1630,
        y: 2050,
      },
      arrows: [
        {
          color: 'amber',
          offset: {
            y: -300,
            x: -500,
          },
          scale: 3.2,
          animationDuration: 15,
          opacity: .05,
        },
        {
          color: 'amber',
          offset: {
            y: -200,
            x: -220,
          },
          scale: 2,
          animationDuration: 10,
          opacity: .07,
        },
      ],}
  }

  get groupType() {
    return this.types[this.type]
  }

  mounted() {
    setTimeout(() => {
      this.beginning = false
    }, 1)
  }
}
